import $ from 'jquery';
import { forEach } from 'lodash';
import angular from 'angular';
import 'slick-carousel/slick/slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import template from './landing.html';
import './landing.styl';

function landingComponent($mdDialog) {

  'ngInject';

  $(document).ready(() => {

    $.get('/carrousel/config.json', () => {

    })
    .done((data) => {
      forEach(data, (img) => {
        $('.js-slick').append(`<div><img src="${img}"></div>`);
      });
    })
    .fail(() => {
      const carrouselImages = [
        '/static/img/carrousel/carrousel1.jpg',
        '/static/img/carrousel/carrousel2.jpg',
        '/static/img/carrousel/carrousel3.jpg',
        '/static/img/carrousel/carrousel4.jpg',
        '/static/img/carrousel/carrousel5.jpg'];

      forEach(carrouselImages, (img) => {
        $('.js-slick').append(`<div><img src="${img}"></div>`);
      });
    })
    .always(() => {
      $('.js-slick').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        dots: false,
        draggable: false,
        arrows: true,
        speed: 1000,
        mobileFirst: true,
      });

      $('.js-slick').on('beforeChange', (event, slick) => {
        $(slick.$slides).removeClass('is-animating');
      });

      $('.js-slick').on('afterChange', (event, slick, currentSlide) => {
        $(slick.$slides.get(currentSlide)).addClass('is-animating');
      });
    });

  });

  this.showChequeInnovacion1Dialog = (ev) => {
    this.showDialog(ev, 'cheque_innovacion1');
  };

  this.showChequeInnovacion2Dialog = (ev) => {
    this.showDialog(ev, 'cheque_innovacion2');
  };

  this.showDialog = (ev, modal) => {
    $mdDialog.show({
      controller: ($scope) => {
        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: 'ctrl',
      templateUrl: `/static/modals/${modal}.html`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  controller: landingComponent,
};



// WEBPACK FOOTER //
// ./src/containers/landing/index.js